var _style, _polygon, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 318.6 318.6",
    style: {
      enableBackground: "new 0 0 318.6 318.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#161616;stroke:#161616;}\n\t.st1{fill:#E4761B;stroke:#E4761B;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:#763D16;stroke:#763D16;stroke-linecap:round;stroke-linejoin:round;}\n\t.st3{fill:#F6851B;stroke:#F6851B;stroke-linecap:round;stroke-linejoin:round;}\n\t.st4{fill:#E2761B;stroke:#E2761B;stroke-linecap:round;stroke-linejoin:round;}\n\t.st5{fill:#CD6116;stroke:#CD6116;stroke-linecap:round;stroke-linejoin:round;}\n\t.st6{fill:#C0AD9E;stroke:#C0AD9E;stroke-linecap:round;stroke-linejoin:round;}\n\t.st7{fill:#D7C1B3;stroke:#D7C1B3;stroke-linecap:round;stroke-linejoin:round;}\n\t.st8{fill:#E4751F;stroke:#E4751F;stroke-linecap:round;stroke-linejoin:round;}\n\t.st9{fill:#233447;stroke:#233447;stroke-linecap:round;stroke-linejoin:round;}\n\t.st10{fill:#161616;stroke:#161616;stroke-linecap:round;stroke-linejoin:round;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "277.3,145.6 272.3,142 280.3,134.7 274.2,129.9 282.2,123.8 276.9,119.8 285.3,79 272.7,41.1  191.6,71.4 124.1,71.4 43,41.1 30.4,79 38.9,119.8 33.5,123.8 41.5,129.9 35.4,134.7 43.4,142 38.4,145.6 49.9,159.1 32.5,213.3  48.6,268.6 105.3,253 116.3,262 138.7,277.5 177,277.5 199.4,262 210.4,253 267.1,268.6 283.3,213.3 265.8,159.1 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "105.3,253 48.6,268.6 32.5,213.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "283.3,213.3 267.1,268.6 210.4,253  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "265.8,159.1 213.5,143.8 231.8,139  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "49.9,159.1 84,139 102.2,143.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "43.4,142 41.5,129.9 84,139  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "272.3,142 231.8,139 274.2,129.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "272.3,142 265.8,159.1 231.8,139  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "43.4,142 84,139 49.9,159.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "231.8,139 276.9,119.8 274.2,129.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "84,139 41.5,129.9 38.9,119.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "124.1,71.4 191.6,71.4 176.5,112.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "176.5,112.5 139.2,112.5 124.1,71.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "276.9,119.8 231.8,139 231,87.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "102.2,143.8 84,139 84.7,87.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "84.7,87.4 84,139 38.9,119.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "231,87.4 231.8,139 213.5,143.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "139.2,112.5 43,41.1 124.1,71.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "272.7,41.1 176.5,112.5 191.6,71.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "210.4,253 236.9,213.3 283.3,213.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "32.5,213.3 78.9,213.3 105.3,253  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "229.3,167.7 283.3,213.3 236.9,213.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "86.4,167.7 32.5,213.3 49.9,159.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "78.9,213.3 32.5,213.3 86.4,167.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "229.3,167.7 265.8,159.1 283.3,213.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "84.7,87.4 139.2,112.5 102.2,143.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "213.5,143.8 176.5,112.5 231,87.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "265.8,159.1 272.3,142 277.3,145.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "49.9,159.1 38.4,145.6 43.4,142  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "272.3,142 274.2,129.9 280.3,134.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "43.4,142 35.4,134.7 41.5,129.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "33.5,123.8 38.9,119.8 41.5,129.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "282.2,123.8 274.2,129.9 276.9,119.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "49.9,159.1 102.2,143.8 86.4,167.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "265.8,159.1 229.3,167.7 213.5,143.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "38.9,119.8 30.4,79 84.7,87.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "231,87.4 285.3,79 276.9,119.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "102.2,143.8 139.2,112.5 142.6,170.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "213.5,143.8 229.3,167.7 173.1,170.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "173.1,170.2 176.5,112.5 213.5,143.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "142.6,170.2 86.4,167.7 102.2,143.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "272.7,41.1 285.3,79 231,87.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "43,41.1 139.2,112.5 84.7,87.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "231,87.4 176.5,112.5 272.7,41.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "84.7,87.4 30.4,79 43,41.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "105.3,253 78.9,213.3 110,213.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "210.4,253 205.7,213.7 236.9,213.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "173.1,170.2 142.6,170.2 139.2,112.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "139.2,112.5 176.5,112.5 173.1,170.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "116.3,262 105.3,253 136.8,267.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "178.9,267.9 210.4,253 199.4,262  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "136.6,258.6 136.8,267.9 105.3,253  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "179.2,258.6 210.4,253 178.9,267.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "86.4,167.7 110,213.7 78.9,213.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "236.9,213.3 205.7,213.7 229.3,167.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "86.4,167.7 109.2,190.8 110,213.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "229.3,167.7 205.7,213.7 206.6,190.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "105.3,253 139.2,236.5 136.6,258.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "210.4,253 179.2,258.6 176.5,236.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "139.2,236.5 105.3,253 110,213.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "176.5,236.5 205.7,213.7 210.4,253  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "173.1,170.2 229.3,167.7 206.6,190.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "109.2,190.8 86.4,167.7 142.6,170.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "142.6,170.2 129.1,181.7 109.2,190.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "206.6,190.8 186.6,181.7 173.1,170.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "205.7,213.7 178.3,199.1 206.6,190.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "110,213.7 109.2,190.8 137.4,199.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "137.4,199.1 109.2,190.8 129.1,181.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "178.3,199.1 186.6,181.7 206.6,190.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "186.6,181.7 178.3,199.1 173.1,170.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "129.1,181.7 142.6,170.2 137.4,199.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "199.4,262 177,277.5 178.9,267.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "136.8,267.9 138.7,277.5 116.3,262  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "178.3,199.1 171.8,188.4 173.1,170.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "137.4,199.1 142.6,170.2 143.9,188.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "173.1,170.2 171.8,188.4 143.9,188.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "143.9,188.4 142.6,170.2 173.1,170.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "178.3,199.1 205.7,213.7 176.5,236.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "139.2,236.5 110,213.7 137.4,199.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "137.4,199.1 144,233.2 139.2,236.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "176.5,236.5 171.7,233.2 178.3,199.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "171.8,188.4 178.3,199.1 171.7,233.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "143.9,188.4 144,233.2 137.4,199.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "143.9,188.4 171.8,188.4 171.7,233.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "171.7,233.2 144,233.2 143.9,188.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "179.2,258.6 178.9,267.9 177,277.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "138.7,277.5 136.8,267.9 136.6,258.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "136.6,258.6 139,256.4 138.7,277.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "177,277.5 176.7,256.4 179.2,258.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "138.7,277.5 139,256.4 176.7,256.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "176.7,256.4 177,277.5 138.7,277.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "176.5,236.5 179.2,258.6 176.7,256.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "139,256.4 136.6,258.6 139.2,236.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "139.2,236.5 140.7,241.2 139,256.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "176.7,256.4 175,241.2 176.5,236.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "143.7,237.7 140.7,241.2 139.2,236.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "176.5,236.5 175,241.2 172,237.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "172,237.7 171.7,233.2 176.5,236.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "139.2,236.5 144,233.2 143.7,237.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "171.7,233.2 172,237.7 143.7,237.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "143.7,237.7 144,233.2 171.7,233.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "140.7,241.2 175,241.2 176.7,256.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "176.7,256.4 139,256.4 140.7,241.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "140.7,241.2 143.7,237.7 172,237.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "172,237.7 175,241.2 140.7,241.2  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.71224aa8.svg";
export { ForwardRef as ReactComponent };